/** A live SSE socket is not evidence that a conversation turn is running. */
export function isTurnInProgress(turn: { status?: string } | null | undefined): boolean {
  return ["accepted", "queued", "running", "cancelling"].includes(turn?.status || "");
}

export function applyThreadActivity(state: any, snapshot: any): boolean {
  const selected = state.selectedUserThreadId ?? state.aiThreadId;
  if (selected == null || String(selected) !== String(snapshot?.ai_thread_id)) return false;
  const messages = state.messages || [];
  // A just-submitted POST can still be on its way to Horizon when the server
  // takes its snapshot. Let that send's confirmation/error settle it first.
  if (!snapshot.active_turn && messages.some((m: any) => m.user_id !== "neo" && m.pending)) return false;
  const running = isTurnInProgress(snapshot.active_turn);
  state.isLoading = running;
  state.isThinking = running;
  if (!running) {
    state.thinkingSteps = [];
    state.currentThinkingStep = 0;
    const finish = (rows: any[]) => rows.map(m => m.isStreaming ? { ...m, isStreaming: false } : m);
    state.messages = finish(messages);
    state.userThreads = (state.userThreads || []).map((thread: any) =>
      String(thread.ai_thread_id) === String(selected) ? { ...thread, messages: finish(thread.messages || []) } : thread
    );
  }
  return true;
}
